<label
  class="tags-input"
  [attr.for]="instanceId + '-input'"
  [class.tags-input--focused]="isFocused()"
>
  <div class="tags-input__chips">
    @for (tag of value(); track $index; let i = $index) {
      @if (editingIndex() === i) {
        <input
          #editInput
          class="tags-input__chip-edit"
          type="text"
          autocomplete="off"
          [attr.aria-label]="placeholder()"
          [value]="editValue()"
          (input)="onEditInput(editInput.value)"
          (keydown)="onEditKeydown($event, i)"
          (blur)="onEditBlur(i)"
        />
      } @else {
        <span class="tags-input__chip" [class.tags-input__chip--active]="isFocused()">
          <button type="button" class="tags-input__chip-label" (click)="startEditingChip(i)">
            {{ tag }}
          </button>
          <button
            type="button"
            class="tags-input__chip-remove"
            [attr.aria-label]="'task-detail.tags-remove' | translate: { tag }"
            (mousedown)="$event.preventDefault()"
            (click)="removeTag(i)"
          >
            <ocp-themed-icon name="cross.svg" [size]="9" />
          </button>
        </span>
      }
    }
    <input
      #tagInput
      [id]="instanceId + '-input'"
      class="tags-input__input"
      type="text"
      autocomplete="off"
      [value]="inputValue()"
      (input)="onInput(tagInput.value)"
      (keydown)="onKeydown($event)"
      (keydown.escape)="onEscape()"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (paste)="onPaste($event)"
      [attr.placeholder]="value().length === 0 ? placeholder() : ''"
      [attr.aria-label]="placeholder()"
    />
  </div>
</label>
@if (isFocused()) {
  <small class="tags-input__hint">{{ 'task-detail.tags-hint' | translate }}</small>
}
